export default {
  getPublishDocumentLink: "files/publish-document?fileName=:fileName",
  getPublishPictureLink: "files/publish-document?fileName=:fileName&picture=true",
  getDocuments: "files/{module}/:module/documents",
  downloadDocumentsZip: "files/:module/:id/documents/download-zip",
  uploadDocument: "files/upload-document",
  uploadHistory: "files/upload-tmp-document",
  uploadPicture: "files/upload-picture",
  updatePdfExtractToPicture: "files/upload-picture-other-source/pdf?extract=true&type=ObjectPicture",
  getSmallPublishPictureLink: "files/publish-small-picture?fileName=:fileName",
  uploadTempDocument: 'files/upload-tmp-document',
  uploadAttachDocument: 'files/upload-attach-document'
};
